import { render, staticRenderFns } from "./__SpecProduct.vue?vue&type=template&id=cae34576&"
import script from "./__SpecProduct.vue?vue&type=script&lang=js&"
export * from "./__SpecProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports